// extracted by mini-css-extract-plugin
export default {"r_l":"d20d72a795 _18c2175936","t":"_298aa2666b"};